import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { RiArrowDownSLine } from "@remixicon/react";
import CompletedOmnis from "../../components/Brand/Reports/CompletedOmnis";
import WeeksSinceObsOmniCountChart from "../../components/Brand/Reports/WeeksSinceObsOmniCount";
import OmniPercentageCards from "../../components/Brand/Insights/OmniPercentages";
import BrandFreshness from "../../components/Brand/Insights/BrandFreshness";
import BrandCountOverTime from "../../components/Brand/Reports/BrandCountOverTime";
import PoiBrandDistributionGlobal from "../../components/Brand/Insights/BrandPoiDistributionGlobal";
import BrandedCountsByCoutry from "../../components/Brand/Insights/BrandedCountsByCountry";
import Top1000Counts from "../../components/Brand/Insights/Top1000Counts";

const BrandsInsightsPage: React.FC = () => {
  document.title = "Executive Insights - Brands";

  const [selectedCountry, setSelectedCountry] = useState<string>("");

  return (
    <Box>
      <Typography
        variant="h3"
        component="h1"
        sx={{ fontSize: "2em", fontWeight: "bold", margin: "20px auto" }}
      >
        Brands Insights
      </Typography>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-omni-development-content"
          id="insights-brand-omni-development-header"
        >
          <Typography variant="h5">Store Locator Development</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CompletedOmnis />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-omni-age-chart-content"
          id="insights-brand-omni-age-chart-header"
        >
          <Typography variant="h5">Distribution of Omnis by Week Since Last Observation</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <WeeksSinceObsOmniCountChart />
          <OmniPercentageCards />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-count-over-time-content"
          id="insights-brand-count-over-time-header"
        >
          <Typography variant="h5">Brand Growth Trends</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <BrandCountOverTime />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-freshness-content"
          id="insights-brand-freshness-header"
        >
          <Typography variant="h5">Brand Freshness</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <BrandFreshness />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-poi-distribution-global-content"
          id="insights-brand-poi-distribution-global-header"
        >
          <Typography variant="h5">Branded POI Distribution</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <PoiBrandDistributionGlobal />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-branded-counts-by-country-content"
          id="insights-brand-branded-counts-by-country-header"
        >
          <Typography variant="h5">Branded Counts by Country</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <BrandedCountsByCoutry />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="insights-brand-top-1000-counts-content"
          id="insights-brand-top-1000-counts-header"
        >
          <Typography variant="h5">Top 1000 Counts</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Top1000Counts />  
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default BrandsInsightsPage;
